import { render, staticRenderFns } from "./WineTemplate.vue?vue&type=template&id=7db8b036"
import script from "./WineTemplate.vue?vue&type=script&lang=js"
export * from "./WineTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports